import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  manuallyApproveUtilityBill,
  recalculateUtilityBill,
  updateUtilityBill,
  updateCollector,
  getUtilityFormat,
  changeUtilityBillStatus,
  createBillInDocument,
} from "api";

export const useUtilityBillMutations = () => {
  const queryClient = useQueryClient();

  const { isLoading: isRecalculating } = useMutation(recalculateUtilityBill);
  const { mutateAsync: manuallyApprove, isLoading: isManuallyApproving } =
    useMutation(manuallyApproveUtilityBill);
  const { mutateAsync: update, isLoading: isUpdating } = useMutation(updateUtilityBill);
  const { mutateAsync: createBill, isLoading: isCreating } = useMutation(createBillInDocument);
  const { mutateAsync: updateBillStatus } = useMutation(changeUtilityBillStatus);
  const { mutateAsync: updateCollectorRequest } = useMutation(updateCollector);
  const { data: formatData, mutate: getFormats } = useMutation(getUtilityFormat);

  return {
    queryClient,
    isRecalculating,
    manuallyApprove,
    isManuallyApproving,
    update,
    isUpdating,
    createBill,
    isCreating,
    updateBillStatus,
    updateCollectorRequest,
    formatData,
    getFormats,
  };
};

